export default "__VITE_ASSET__y3dLWF4y__"